import { Observable } from 'rxjs';
import {
  HttpWalletQrisDecodeCollectionResponse,
  HttpWalletQrisPaymentCollectionResponse,
  HttpWalletQrisRequestPinCollectionResponse,
  HttpWalletQrisTrxStatusCollectionResponse,
  HttpWalletQrisValidatePinCollectionResponse,
} from '../../data/repository/fs-wallet-qris/http-fs-wallet-qris.collection';

import { OtpRequestDTO } from '../usecase/fs-wallet-qris/interface/otp-request.dto';
import { QrisDecodeDTO } from '../usecase/fs-wallet-qris/interface/qris-decode.dto';
import { QrisPaymentDTO } from '../usecase/fs-wallet-qris/interface/qris-payment.dto';
import { QrisTrxStatusDTO } from '../usecase/fs-wallet-qris/interface/qris-trx-status.dto';
import { ValidatePinDTO } from '../usecase/fs-wallet-qris/interface/validate-pin.dto';

export abstract class FSWalletQrisRepository {
  abstract QrisDecode(
    data: QrisDecodeDTO
  ): Observable<HttpWalletQrisDecodeCollectionResponse>;

  abstract QrisPayment(
    data: QrisPaymentDTO
  ): Observable<HttpWalletQrisPaymentCollectionResponse>;

  abstract GetTrxStatus(
    data: QrisTrxStatusDTO
  ): Observable<HttpWalletQrisTrxStatusCollectionResponse>;

  abstract RequestPin(
    data: OtpRequestDTO
  ): Observable<HttpWalletQrisRequestPinCollectionResponse>;

  abstract ValidatePin(
    data: ValidatePinDTO
  ): Observable<HttpWalletQrisValidatePinCollectionResponse>;
}
